import { IIndexTypeCategory } from "../../model/IndexTypeCategory";
import { IIndexTypeGroup } from "../../model/IndexTypeGroup";

export interface TIndexTypeGroupPresentationModel extends IIndexTypeGroup {
  categoryName: string;
  category: IIndexTypeCategory;
  groups: TIndexTypeGroupPresentationModel[];
  childGroups: TIndexTypeGroupPresentationModel[];
}

const IndexTypeGroupPresentationModel = (
  data: IIndexTypeGroup,
  indexTypeCategory?: IIndexTypeCategory[]
) => {
  const category = indexTypeCategory?.find(
    (value) => value.id === data.indexTypeCategoryId
  );
  const handler: ProxyHandler<IIndexTypeGroup> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "categoryName":
          return category?.name;
        case "category":
          return category;
        case "groups":
          return data.groups?.map((item) =>
            IndexTypeGroupPresentationModel(item, indexTypeCategory)
          );
        case "childGroups":
          return data.childGroups?.map((item) =>
            IndexTypeGroupPresentationModel(item, indexTypeCategory)
          );
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "categoryName":
        case "category":
        case "groups":
        case "childGroups":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IIndexTypeGroup, TIndexTypeGroupPresentationModel>(
    data,
    handler
  );
};

export default IndexTypeGroupPresentationModel;
